import { ReadActionKey } from 'owa-outlook-service-options';

// The order of these are Right to Left
// Meaning index 0 will be the right most element
export const menuKeysInOrder: ReadActionKey[] = [
    'Reply',
    'ReplyAll',
    'Forward',
    'OtherReplyActions',
    '-',
    'Delete',
    'MarkReadUnread',
    'FlagUnflag',
    'AddToProjectSpace',
    'AddToSafeSenders',
    'MessageSafety',
    '-',
    'Print',
    'View',
    '-',
    'Addins',
    'CustomizeActions',
    'AdvancedActions',
    'ToggleAmp',
    'SetReaction',
    'ToggleDarkMode',
];
